import styled from 'styled-components';
import { isDesktop } from 'react-device-detect';

export const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 31, 0.35);
  z-index: 1000;
  opacity: ${(props) => (props.show ? 1 : 0)};
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.show ? 'auto' : 'none')};
  transition: opacity 350ms ease-in-out, visibility 0ms linear ${(props) => (props.show ? '0ms' : '350ms')};
`;

export const ModalContent = styled.div`
  background-color: white;
  border: 1px solid #ddd;
  padding: 2px;
  max-width: 100vh;
  max-height: 90vh;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  text-align: start;
  z-index: 1001;
  display: flex;
  flex-direction: row;
  cursor: default;

  &::-webkit-scrollbar {
    display: none;
  }

  p {
    color: #333;
  }

  span {
    color: #aaa;
    float: right;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: #555;
    }
  }

  ${isDesktop
  && `
  max-width: 950px;
  `}
`;

export const LeftContainer = styled.div`
  flex: 0.8;
  display: flex;
  border: 2px solid black;
  border-right: none;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 950px) {
    display: none;
  }
`;

export const InfoImg = styled.img`
  max-width: 100%;
  height: auto;
`;

export const RightContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${isDesktop
  && `
    border: 2px solid black;
    align-items: flex-end;
    @media (min-width: 950px) {
      border-left: none;
    }
  `}
`;

export const HeaderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  border: 2px solid black;
  border-bottom: none;

  ${isDesktop
  && `
    border: none;
    align-items: flex-end;
  `}
`;

export const AlmaLogoBlack = styled.img`
  height: auto;
  margin-top: 4px;
  align-self: flex-end;
  max-width: 135px;
    margin-bottom: 6px;

  @media screen and (max-width: 1024px) {
    align-self: flex-end;
    max-width: 125px;
    margin-bottom: 8px;
  }
`;

export const ParagraphTitle = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.55em;
  margin-top: 4px;
  font-weight: bold;

  ${isDesktop
  && `
    text-align: right;
  `}
`;

export const ParagraphDescription = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.6em;
  line-height: 1.35;
  width: 230px;

  ${isDesktop
  && `
    width: 280px;
    text-align: right;
  `}
`;

export const ParagraphVersion = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.55em;
  margin-bottom: 0;

  ${isDesktop
  && `
    text-align: right;
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  border: 2px solid black;
  border-top: none;
  width: 100%;

  ${isDesktop
  && `
    flex-direction: row;
    border: none;
  `}
`;

export const LeftContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const RightContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const IconWithDescriptionContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
  cursor: pointer;
`;

export const ParagraphContentTitleBold = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.55em;
  margin-bottom: 0;
  font-weight: bold;
`;

export const ParagraphContainer = styled.div`
  flex-direction: column;
`;

export const ParagraphContentTitle = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.55em;
  margin-bottom: 0;

  ${isDesktop
  && `
    width: 125px;   
  `}
`;

export const ParagraphContentAddressBold = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.55em;
  margin-bottom: 0;
  font-weight: 800;
`;

export const ParagraphContentAddress = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.5em;
  margin-bottom: 0;
  width: 150px;

  ${isDesktop
  && `
    width: 300px;
  `}
`;

export const ParagraphContentDescription = styled.p`
  color: #333;
  text-align: left;
  font-size: 0.55em;
  line-height: 1.3;
  margin-bottom: 6px;
  position: relative;
  padding-left: 15px;
  margin-left: 10px;
  width: 180px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 3px;
    background-color: #333;
    border-radius: 50%;
  }
`;

export const StyledIcon = styled.img`
  max-width: 36px;
  height: auto;
  margin: 0 10px;
`;
